import { AddIcon } from 'tuui';
import styles from './subscriptionAddItemButton.module.scss';

export const SubscriptionAddItemButton = ({ onClick, label }) => {
    return (
        <div role="button" className={styles['container']} onClick={onClick}>
            <AddIcon />
            {label}
        </div>
    );
};
